<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="cancel()" />
</div>
<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col class="text-left">
        <h1 class="small-h1">Lad bilen smart med Ishavskraft</h1>
        <p>
          Vi samarbeider med Enode for å tilby smartlading. Du kan lære mer om
          hvordan det fungerer og hvilke biler som støttes
          <a
            target="_blank"
            href="https://www.ishavskraft.no/privat/smartlading"
            ><strong>her</strong>
            <ion-icon name="open-outline" size="small"></ion-icon></a
          >.
        </p>

        <h2>Hvordan funker det?</h2>
        <p>
          Når du kobler til laderen vil vi hensynta mengde strøm laderen
          leverer, og kommende nettleie- og strømpriser. Strømstøtte blir også
          medregnet der det er aktuelt. Ser vi dette i sammenheng med fristen du
          har satt, så finner vi den rimeligste perioden for når din bil skal
          lade.
        </p>
        <p class="mb-6">Bra for pengeboka, og bra for miljøet!</p>
        <img src="/assets/img/enode/enode-charging.svg" />

        <h2>Kjente problemer</h2>
        <ol class="text-left">
          <li>
            <p>
              Hvis du har aktivert tidsplaner eller annen smart
              ladefunksjonalitet via laderen, kjøretøyet eller andre apper, vil
              disse skape problemer for smartladingen.
            </p>
          </li>
          <li>
            <p>
              Hvis du har lastbalansering på laderen din eller har en enhet
              koblet til HAN-porten, vil dette skape problemer for
              smartladingen.
            </p>
          </li>
          <li>
            <p>
              Om du har en lader som må aktiveres med brikke eller app, vil
              dette skape problemer for smartladingen.
            </p>
          </li>
        </ol>
        <img src="/assets/img/enode/enode-woman-screen.svg" />
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
